import { columnsContractsType } from "pages/contracts-pages/types/columsContract.types";
import { IElectronicDocuments } from "shared/models";

export const convertDataContracts = (data: any): IElectronicDocuments => {

    const content = () => {
            return data?.content?.map((item: any): columnsContractsType => {
                return {
                    contract: item?.number,
                    contractId: item?.id,
                    providerNit: item?.provider.employerIdNumber,
                    providerName: item?.provider.name,
                    totalValue: item?.totalValue,
                    contractStartAt: item?.contractStartAt,
                    contractEndAt: item?.contractEndAt,
                    cdpNumber: item?.cdpNumber,
                    currentBalance: item?.currentBalance,
                }
            })
    } 

    return {
        content: content(),
        totalElements: data.totalElements,
        number: data.number,
        size: data.size,
        contentSize: data.contentSize,
    }

}